

















import { defineComponent, onMounted, reactive, ref, SetupContext } from '@vue/composition-api'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import shader from '@/assets/shader/effect.frag'

type TPoint = {
  posX: number
  posY: number
  time: number
  beginTime: number
  willDelete?: boolean
}

export default defineComponent({
  setup(_, context: SetupContext) {
    const points = reactive<TPoint[]>([])
    const screen = reactive<{ width: number; height: number }>({
      width: -1,
      height: -1,
    })

    const resizeHandler = () => {
      screen.width = -1
      screen.height = -1
      context.root.$nextTick(() => {
        screen.width = window.innerWidth
        screen.height = window.innerHeight
      })
    }

    const clickableRef = ref(null)

    onMounted(() => {
      window.addEventListener('resize', resizeHandler)
      resizeHandler()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      clickableRef.value.addEventListener('click', async (e: MouseEvent) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const clickableHeight = clickableRef.value.getBoundingClientRect().top

        const obj = {
          posX: e.clientX,
          posY: e.clientY - clickableHeight,
          beginTime: Date.now(),
          time: 0,
          id: Date.now(),
        }
        console.log(clickableHeight, window.innerHeight, clickableHeight - window.innerHeight)

        points.push(obj)

        // const res = await fetch(
        //   'https://asia-northeast1-project-fo.cloudfunctions.net/v1/counter',
        //   {
        //     method: 'POST',
        //   }
        // )
        // console.log(res)
      })
    })

    const glslUpdate = () => {
      const narr = []
      for (let i = 0; i < points.length; i++) {
        const time = (Date.now() - points[i].beginTime) / 1000
        if (time > 1) continue
        else narr.push({ ...points[i], time })
      }
      while (narr.length > 9) {
        narr.shift()
      }
      while (narr.length < 9) {
        narr.push({ posX: 0, posY: 0, beginTime: 0, time: 0, id: Date.now() })
      }

      points.splice(0, points.length)
      points.push(...narr)
    }

    return {
      points,
      clickableRef,
      glslUpdate,
      screen,
      shader,
    }
  },
})
